<template>
  <div id="app">
    <Header/>
    <main>
      <router-view/>
    </main>
    <Footer/>
    <Overlay ref="overlay" />
    <Banner ref="banner" />
  </div>
</template>

<script>
  // import Store from '@/store';
  import Header from '@/components/ui/Header';
  import Footer from '@/components/ui/Footer';
  import Banner from '@/components/ui/Banner';
  import Overlay from '@/components/ui/Overlay';

  export default {
    name: 'App',
    components: {
      Footer,
      Header,
      Banner,
      Overlay,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {},
    //---------------------------------------------------
    //
    //  Data Model
    //
    //---------------------------------------------------
    data() {
      return {
      };
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {
      /*
      $route: {
        handler(value) {
          console.log('new route:', value);
        },
        immediate: true,
      },
      */
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    mounted() {
      /*
      if (!Store.cookies) {
        this.$refs.banner.show('cookies');
      }
      */
      window.addEventListener('scroll', this.$b.analytics.trackScrollDepth);
      document.documentElement.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
    },
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
    },
  };
</script>

<style lang="scss">
  @import '~scss/app';
  @import '~scss/variables';
  @import '~scss/mixins';

  main {
    display: block;
    @include max-width-constraints;
    min-height: calc(100vh - 233px);
    min-height: calc((var(--vh, 1vh) * 100) - 233px);
    padding: 0;

    @include screen-tablet {
      min-height: calc(100vh - 208px);
      min-height: calc((var(--vh, 1vh) * 100) - 208px);
    }
  }
</style>
